import script from "./PatientListingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientListingPage.vue?vue&type=script&setup=true&lang=ts"

import "./PatientListingPage.vue?vue&type=style&index=0&id=7fd0bdea&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fd0bdea"]])

export default __exports__